(function () {
  var root = document.querySelector('[data-qmv-root]');
  if (!root || root.hasAttribute('data-qmv-ready')) return;
  root.setAttribute('data-qmv-ready', '');
  var cards = [].slice.call(root.querySelectorAll('.qm-ugcv__card'));
  var showPosters = function () {
    cards.forEach(function (card) {
      var v = card.querySelector('video');
      if (v && v.getAttribute('data-qmv-poster')) { v.setAttribute('poster', v.getAttribute('data-qmv-poster')); v.removeAttribute('data-qmv-poster'); }
    });
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); showPosters(); }
    }, { rootMargin: '600px 0px' });
    io.observe(root);
  } else { showPosters(); }
  var setPlayLabel = function (card, playing) {
    var b = card.querySelector('[data-qmv-play]');
    b.setAttribute('aria-label', b.getAttribute(playing ? 'data-qmv-label-pause' : 'data-qmv-label-play'));
    card.classList.toggle('is-playing', playing);
  };
  var setSound = function (card, on) {
    var v = card.querySelector('video'), s = card.querySelector('[data-qmv-sound]');
    v.muted = !on;
    s.setAttribute('aria-pressed', on ? 'true' : 'false');
    s.setAttribute('aria-label', s.getAttribute(on ? 'data-qmv-label-off' : 'data-qmv-label-on'));
  };
  var pauseOthers = function (current) {
    cards.forEach(function (card) {
      if (card === current) return;
      var v = card.querySelector('video');
      if (v && !v.paused) v.pause();
    });
  };
  cards.forEach(function (card) {
    var v = card.querySelector('video');
    var play = card.querySelector('[data-qmv-play]');
    var sound = card.querySelector('[data-qmv-sound]');
    var toggle = function () {
      if (!v.getAttribute('src')) { showPosters(); v.setAttribute('src', v.getAttribute('data-qmv-src')); v.muted = true; sound.hidden = false; }
      if (v.paused) { pauseOthers(card); var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
    };
    play.addEventListener('click', toggle);
    v.addEventListener('click', toggle);
    sound.addEventListener('click', function () { setSound(card, v.muted); });
    v.addEventListener('play', function () { setPlayLabel(card, true); });
    v.addEventListener('pause', function () { setPlayLabel(card, false); });
    v.addEventListener('ended', function () { setPlayLabel(card, false); });
  });
})();
